import * as tslib_1 from "tslib";
import { getConsumerMailbox } from '../services/getConsumerMailbox';
import { resetConsumerDefaultFromStore } from '../actions/defaultFrom/resetConsumerDefaultFromStore';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
export function loadDefaultAddressOption() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isControlFeatureEnabled('doc-consumerUrl')) return [3 /*break*/, 2];
                    return [4 /*yield*/, getConsumerMailbox()];
                case 1:
                    response = _a.sent();
                    resetConsumerDefaultFromStore(response.ErrorMessage ? null : response.Options);
                    return [3 /*break*/, 3];
                case 2:
                    Promise.resolve();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=loadDefaultAddressOption.js.map